import CardInfoItem from "./card-info-item";

export default CardInfoItem;